module.exports = __webpack_public_path__ + "static/img/api.a430d37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/frontProJect/fangzhou/api.png
// module id = 2pDD
// module chunks = 1